// Social Media Icons
import facebookIcon from "../assets/img/socialMediaIcons/facebook.svg";
import instagramIcon from "../assets/img/socialMediaIcons/instagram.svg";
import linkedinIcon from "../assets/img/socialMediaIcons/linkedin.svg";
import pinterestIcon from "../assets/img/socialMediaIcons/pinterest.svg";
import xIcon from "../assets/img/socialMediaIcons/x.svg";

// Platform configurations for icons/colors
export const PLATFORM_CONFIGS = {
  pinterest: {
    name: "Pinterest",
    color: "#E60023",
    icon: pinterestIcon,
    implemented: true,
    supportsAltText: true,
    description: "Share visual content and drive traffic to your website",
  },
  x: {
    name: "X",
    color: "#1DA1F2",
    icon: xIcon,
    implemented: true,
    supportsAltText: false,
    description: "Share updates and engage with your audience in real-time",
  },
  instagram: {
    name: "Instagram",
    color: "#E4405F",
    icon: instagramIcon,
    implemented: true,
    supportsAltText: false,
    description: "Share photos and stories with visual storytelling",
  },
  facebook: {
    name: "Facebook",
    color: "#1877F2",
    icon: facebookIcon,
    implemented: true,
    supportsAltText: false,
    description:
      "Connect with friends and share content on the world's largest social network",
  },
  linkedin: {
    name: "LinkedIn",
    color: "#0A66C2",
    icon: linkedinIcon,
    implemented: true,
    supportsAltText: true,
    description: "Build professional connections and share business content",
  },
};

// Helper function to get platform config
export const getPlatformConfig = (platform) => {
  return PLATFORM_CONFIGS[platform] || null;
};

// Helper function to check if a platform supports alt text
export const platformSupportsAltText = (platform) => {
  const config = getPlatformConfig(platform);
  return config ? config.supportsAltText : false;
};

// Helper function to get all implemented platforms
export const getImplementedPlatforms = () => {
  return Object.keys(PLATFORM_CONFIGS).filter(
    (platform) => PLATFORM_CONFIGS[platform].implemented
  );
};

// Helper function to get all platforms
export const getAllPlatforms = () => {
  return Object.keys(PLATFORM_CONFIGS);
};
